<template>
    <div class="buyerDetailWrap11">
        <el-row :gutter="20">
            <el-col :span="12">
                <div class="leftBox">
                    <div class="title">{{brandDetailBasic.userName}}</div>
                    <div class="content">
                        <ul>
                            <li>
                                <span class="label">手机号码</span>
                                <span class="text">{{brandDetailBasic.phone}}</span>
                            </li>
                            <li>
                                <span class="label">公司</span>
                                <span class="text">{{brandDetailBasic.userCompanyName}}</span>
                            </li>
                            <li>
                                <span class="label">收藏数量</span>
                                <span class="text">{{brandDetailBasic.ces}}</span>
                            </li>
                            <li>
                                <span class="label">报名时间</span>
                                <span class="text">{{brandDetailBasic.userRegisterTime}}</span>
                            </li>
                            <li>
                                <span class="label">上级姓名</span>
                                <span class="text">{{brandDetailBasic.superiorName}}</span>
                            </li>
                            <li>
                                <span class="label">权限</span>
                                <div class="powerBox" v-if="function_changeCustomerPower">
                                    <div class="powerItem">
                                        <span class="powerLabel">改变上下级关系</span>
                                        <span>{{isAllowChangeRelation}}</span>
                                        <el-switch  :active-value="'y'" :inactive-value="'n'" v-model="isAllowChangeRelation" @change="changeRelationPower"></el-switch>

                                    </div>
                                    <div class="powerItem">
                                        <span class="powerLabel">查看受邀人购买情况</span>
                                        <span>{{isAllowViewFriendDetail}}</span>
                                        <el-switch :active-value="'y'" :inactive-value="'n'"  v-model="isAllowViewFriendDetail" @change="changeViewPower"></el-switch>

                                    </div>
                                </div>

                            </li>
                            <li>
                                <span class="label">是否到场</span>
                                <span class="blue text" v-if="brandDetailBasic.userIsCheckin=='y'">是</span>
                                <span class="red text"  v-if="brandDetailBasic.userIsCheckin=='n'">否</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </el-col>
            <el-col :span="11">
                <div class="rightBox" >
                    <el-row >
                        <div class="colorSmallBlock bg1 firstHrefBox" @click='toInviteDetail'>
                            <div class="iconBox"><i class="el-icon-notebook-2"></i></div>
                            <div class="textBox">
                                <span class="num">{{brandDetailInvite.inviteNum}}</span>
                                <span class="unit">人</span>
                            </div>
                            <div class="desBox">{{brandDetailBasic.userName}}邀请人数</div>
                        </div>
                    </el-row>
                    <el-row :gutter='10' >
                        <el-col :span="12">
                            <div class="colorSmallBlock bg2 secondHrefBox" @click='toOrderDetail'>
                                <div class="iconBox"><i class="el-icon-notebook-2"></i></div>
                                <div class="textBox">
                                    <span class="num">{{brandDetailOrder.totalAmount}}</span>
                                    <span class="unit">元</span>
                                </div>
                                <div class="desBox">{{brandDetailBasic.userName}}成交总金额</div>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="colorSmallBlock bg2 secondHrefBox" @click='toOrderDetail'>
                                <div class="iconBox"><i class="el-icon-notebook-2"></i></div>
                                <div class="textBox">
                                    <span class="num">{{brandDetailOrder.totalNum}}</span>
                                    <span class="unit">笔</span>
                                </div>
                                <div class="desBox">{{brandDetailBasic.userName}}成交总笔数</div>
                            </div>
                        </el-col>

                    </el-row>
                    <el-row :gutter='10' class="">
                        <el-col :span="12">
                            <div class="colorSmallBlock bg3 thirdHrefBox" @click='toFriendDetail' >
                                <div class="iconBox"><i class="el-icon-notebook-2"></i></div>
                                <div class="textBox">
                                    <span class="num">{{brandDetailSonorder.totalAmount}}</span>
                                    <span class="unit">元</span>
                                </div>
                                <div class="desBox">{{brandDetailBasic.userName}}邀请的客户成交总金额</div>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="colorSmallBlock bg3 thirdHrefBox" @click='toFriendDetail' >
                                <div class="iconBox"><i class="el-icon-notebook-2"></i></div>
                                <div class="textBox">
                                    <span class="num">{{brandDetailSonorder.totalNum}}</span>
                                    <span class="unit">笔</span>
                                </div>
                                <div class="desBox">{{brandDetailBasic.userName}}邀请的客户成交总笔数</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
        import {        json,       wordData,        utils    } from '@/common/common.js'
        import {        ajaxPost,api    } from '@/common/request.js'
    // 
    export default {
        name: 'HelloWorld',
        data() {
            return {
                isLoading: false,
                conferenceId:'',
                userId:'',
                brandDetailBasic:{},
                brandDetailInvite:{},
                brandDetailOrder:{},
                brandDetailSonorder:{},
                
                isAllowChangeRelation:'',
                isAllowViewFriendDetail:'',
                isArrived:'',
            }
        },
        components: {},
        computed: {
            function_changeCustomerPower(){
                return utils.getCurrentFunction().indexOf("changeCustomerPower")>-1
            },
            IMG_PREV() {
                return api.imgPrev
            },

        },
        methods: {
            changeRelationPower(){
                let _this=this
                if(!confirm("是否修改客户权限")){
                    _this.isAllowChangeRelation=_this.isAllowChangeRelation=='n'?'y':'n'
                    return false
                }else{
                    //isAllowChangeRelation

                }
            },
            changeViewPower(){
                let _this=this
                if(!confirm("是否修改客户权限")){
                    _this.isAllowViewFriendDetail=_this.isAllowViewFriendDetail=='n'?'y':'n'
                    return false
                }else{
                    //isAllowViewFriendDetail
                
                }
                
            },
            toInviteDetail(){
                let _this=this
               this.$router.push({name: 'activeInnerBuyerInviteDetail',params: { userId: _this.userId ,userName: _this.brandDetailBasic.userName,conferenceId:_this.conferenceId}}) 
            },
            toOrderDetail(){
                 let _this=this
                this.$router.push({name: 'activeInnerBuyerOrderDetail',params: { userId: _this.userId ,userName: _this.brandDetailBasic.userName ,conferenceId:_this.conferenceId}}) 
            },
            toFriendDetail(){
                 let _this=this
                this.$router.push({name: 'activeInnerBuyerFriendDetail',params: { userId: _this.userId ,userName: _this.brandDetailBasic.userName ,conferenceId:_this.conferenceId}})  
            },
            getParams() {
                this.conferenceId = this.$route.params.conferenceId
                this.userId = this.$route.params.userId
            },
            getDetail(){
                let _this=this
                let arg={
                    "conferenceId":_this.conferenceId,
                    "userId":_this.userId
                }
                ajaxPost('/admin/getbuyerDetail',arg).then(function(res) {
                    if(res.errorCode==200){
                         _this.brandDetailBasic=res.data.brandDetailbasic?res.data.brandDetailbasic:{}
                         _this.brandDetailInvite=res.data.brandDetailinvite?res.data.brandDetailinvite:{}
                         _this.brandDetailOrder=res.data.brandDetailorder?res.data.brandDetailorder:{}
                         _this.brandDetailSonorder=res.data.brandDetailSonorder?res.data.brandDetailSonorder:{}
                         
                         if(_this.brandDetailBasic.userAuthInfo){
                             _this.isAllowChangeRelation=JSON.parse(_this.brandDetailBasic.userAuthInfo).isOverrideCode
                             _this.isAllowViewFriendDetail=JSON.parse(_this.brandDetailBasic.userAuthInfo).isShowSubData
                         }
                    }
                }, function(res) {
                
                })
            }
        },
        mounted() {
            this.getParams()
            this.getDetail()
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    // *{outline: 1px solid blue;}
    .buyerDetailWrap11 {
        width: 980px; padding:20px 50px;;
        .leftBox{  box-shadow: 0px 4px 8px #aaa;
            .title{background: #49586F;padding:15px 20px;font-size: 20px;color:#eee;}
            .content{background: #fff; padding:18px 20px;
                li{padding:5px;
                    .label{display: inline-block;width: 60px; text-align-last: justify;}
                    .text{display: inline-block;padding-left:40px;}
                }
                .powerBox{
                    display: inline-block;padding-left:40px;vertical-align: top;
                    .powerItem{padding-bottom: 5px;}
                }
            }
        }
        .rightBox{
            .el-row{margin-bottom: 10px;}
        }
        .firstHrefBox:hover,.secondHrefBox:hover,.thirdHrefBox:hover{ background: royalblue;cursor: pointer;}
    }
</style>



// WEBPACK FOOTER //
// src/pages/active/innerPage/buyerDetail.vue